import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { PRICING } from '../../../config';

export const generateReceiptPDF = (receipt) => {
  const doc = new jsPDF();

  // Add header
  doc.setFontSize(20);
  doc.setTextColor(...PRICING.BRAND_COLORS.PRIMARY); // YoungPresso orange
  doc.text("YoungPresso ( A Mettlesome Product )", 105, 20, { align: "center" });

  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text("Payment Receipt", 105, 30, { align: "center" });

  // Add receipt details
  doc.setFontSize(10);
  doc.text("Receipt Date: " + new Date(receipt.receiptDate).toLocaleDateString(), 15, 40);
  doc.text("Receipt No: REC-" + (receipt.paymentId ? receipt.paymentId.slice(-6) : receipt._id.slice(-6)), 15, 45);
  doc.text("GST No: " + (receipt.gstNumber || PRICING.GST.NUMBER), 15, 50);

  // Customer info
  doc.setFontSize(12);
  doc.text("Customer Information", 15, 60);
  doc.line(15, 62, 195, 62);

  doc.setFontSize(10);
  doc.text("Name: " + (receipt.customerName || 'N/A'), 15, 70);
  doc.text("Email: " + (receipt.customerEmail || 'N/A'), 15, 75);
  doc.text("Phone: " + (receipt.customerPhone || 'N/A'), 15, 80);

  // Payment details
  doc.setFontSize(12);
  doc.text("Payment Details", 15, 90);
  doc.line(15, 92, 195, 92);

  // Create table for payment details
  const tableData = [
    ["Plan", receipt.planName || 'N/A'],
    ["Payment ID", receipt.paymentId || 'N/A'],
    ["Subscription ID", receipt.subscriptionId || 'N/A'],
    ["Payment Date", new Date(receipt.receiptDate).toLocaleDateString()]
  ];

  autoTable(doc, {
    startY: 95,
    head: [["Item", "Details"]],
    body: tableData,
    theme: 'grid',
    headStyles: { fillColor: [255, 107, 53] }
  });

  // Add GST breakdown
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(12);
  doc.text("Amount Breakdown", 15, finalY);
  doc.line(15, finalY + 2, 195, finalY + 2);

  // Create the receipt body rows
  const receiptRows = [
    ["Base Amount", "Rs. " + (receipt.baseAmount || 0).toFixed(2)],
    ["GST (" + (receipt.gstRate || PRICING.GST.RATE) + "%)", "Rs. " + (receipt.gstAmount || 0).toFixed(2)],
    ["Total Amount", "Rs. " + (receipt.amount || 0).toFixed(2)]
  ];

  autoTable(doc, {
    startY: finalY + 5,
    head: [["Description", "Amount (₹)"]],
    body: receiptRows,
    theme: 'grid',
    headStyles: { fillColor: [255, 107, 53] }
  });

  // Add footer
  const gstFinalY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : finalY + 60;
  doc.setFontSize(10);
  doc.text("Thank you for subscribing to YoungPresso!", 105, gstFinalY, { align: "center" });
  doc.text("For any queries, please contact support@youngpresso.com", 105, gstFinalY + 5, { align: "center" });

  // Download the PDF
  doc.save(`YoungPresso_Receipt_${receipt.paymentId || receipt._id}.pdf`);
};
